export default {
    getUpdatedArrayItems (newArray, savedArray) {
        function arrayToStringify (sourceList) {
            let result = new Set()
            for (const source of sourceList) {
                result.add(JSON.stringify(source))
            }
            return result
        }

        const savedArrayStringify = arrayToStringify(savedArray)
        return newArray.filter(item => !savedArrayStringify.has(JSON.stringify(item)))
    },
    copyObjectProperties(destItem, srcItem) {
      for (const key of Object.keys(destItem)) {
        destItem[key] = srcItem[key]
      }
    }
}